import remoteApi from "common/remote/api";
import { UserLoginProps, UserLoggedInModel } from "./user.model";

/**
 *
 * @param UserLoginProps username and password for user to log in,.
 * @returns Promise
 *
 * @todo change the api call with json data and not FormData instance
 */
export const login = ({
	username, // params.username
	password, // params.password
}: UserLoginProps): Promise<UserLoggedInModel> => {
	const params = new FormData();
	params.append("username", username);
	params.append("password", password);
	return remoteApi.post("/auth/login", params);
};
